// src/components/modals/ReprintModal.jsx
import React from "react";
import Ticket from "../../../components/Ticket";// ajusta la ruta según donde tengas tu Ticket.jsx

export default function ReprintModal({ show, sale, onClose }) {
  if (!show || !sale) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0, left: 0,
        width: "100vw", height: "100vh",
        backgroundColor: "rgba(0,0,0,0.6)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "white",
          borderRadius: "8px",
          padding: "16px",
          maxWidth: "420px",
          width: "100%",
          maxHeight: "90vh",
          overflowY: "auto",
          position: "relative",
        }}
      >
        {/* Botón cerrar */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "10px", right: "10px",
            background: "#ef4444",
            color: "white",
            border: "none",
            borderRadius: "50%",
            width: "30px", height: "30px",
            cursor: "pointer",
            fontSize: "16px",
            zIndex: 10,
          }}
        >
          ✕
        </button>

        {/* Reutilizamos el Ticket del restaurante */}
        <Ticket
          invoice={sale}
          onAfterPrint={onClose}
        />
      </div>
    </div>
  );
}